import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';
import { IndividualWebhookEndpoint } from './getWebhookEndpoints';

export interface AddWebhookEndpointPayload {
  webhookEndpoint: string;
  businessId: number;
}

export const addWebhookEndpoint = ({
  webhookEndpoint,
  businessId,
}: AddWebhookEndpointPayload): AxiosPromise<IndividualWebhookEndpoint> => {
  return httpClient({
    method: 'POST',
    url: `/super-admin/businesses/${businessId}/integrations/configs`,
    data: {
      webhookEndpoint,
    },
  });
};
